import { useEffect, useState } from "react";
import api from "@/lib/api";
import { Plus, Trash2 } from "lucide-react";

export default function AdminMenusPage() {
  const [loc, setLoc] = useState("header");
  const [menu, setMenu] = useState({ items: [] });

  const load = async () => { const { data } = await api.get(`/admin/menus/${loc}`); setMenu(data || { items: [] }); };
  useEffect(() => { load(); /* eslint-disable-next-line */ }, [loc]);

  const update = (i, p) => { const items = (menu.items || []).slice(); items[i] = { ...items[i], ...p }; setMenu({ ...menu, items }); };
  const remove = (i) => { const items = (menu.items || []).slice(); items.splice(i, 1); setMenu({ ...menu, items }); };
  const add = () => setMenu({ ...menu, items: [...(menu.items || []), { label_tr: "", label_en: "", url: "/", order: (menu.items || []).length + 1 }] });
  const save = async () => { await api.put(`/admin/menus/${loc}`, { location: loc, items: menu.items || [] }); load(); };

  return (
    <div data-testid="admin-menus">
      <h1 className="font-serif text-4xl text-cc-text mb-2">Menüler</h1>
      <p className="text-sm text-cc-muted mb-6">Header ve footer menü düzenleyici</p>

      <div className="flex gap-3 mb-6">
        {["header", "footer"].map((l) => (
          <button key={l} onClick={() => setLoc(l)} className={`text-xs uppercase tracking-overline px-3 py-2 border ${loc === l ? "border-cc-sepia text-cc-sepia" : "border-admin-border text-cc-muted"}`}>{l}</button>
        ))}
      </div>

      <div className="bg-white border border-admin-border p-5 mb-6">
        {(menu.items || []).map((it, i) => (
          <div key={i} className="grid md:grid-cols-12 gap-2 mb-3 items-end">
            <label className="md:col-span-3 text-xs text-cc-muted">TR <input value={it.label_tr || ""} onChange={(e) => update(i, { label_tr: e.target.value })} className="cc-input" /></label>
            <label className="md:col-span-3 text-xs text-cc-muted">EN <input value={it.label_en || ""} onChange={(e) => update(i, { label_en: e.target.value })} className="cc-input" /></label>
            <label className="md:col-span-4 text-xs text-cc-muted">URL <input value={it.url || ""} onChange={(e) => update(i, { url: e.target.value })} className="cc-input" /></label>
            <label className="md:col-span-1 text-xs text-cc-muted">Sıra <input type="number" value={it.order || 0} onChange={(e) => update(i, { order: parseInt(e.target.value) })} className="cc-input" /></label>
            <button onClick={() => remove(i)} className="md:col-span-1 text-cc-muted hover:text-red-600"><Trash2 size={14} /></button>
          </div>
        ))}
        <button onClick={add} className="text-xs text-cc-sepia flex items-center gap-1"><Plus size={12} /> Madde ekle</button>
      </div>

      <button onClick={save} className="cc-btn">Kaydet</button>
    </div>
  );
}
